/**
 * Created by jayed.talukder on 9/18/2018.
 */

import { Pipe, PipeTransform } from '@angular/core';
import {EntitySetting} from "../../models/entity-setting.model";
// import * as fromModel from '../../models';

@Pipe({
    standalone: false,
    name: 'searchTransactionByCountryName' })
export class SearchTransactionByCountryNamePipe implements PipeTransform {
  transform(input: EntitySetting[], searchText: string) {
    if (!searchText) {
      return input;
    }
    const lowerCased = searchText.toLowerCase();
    return input.filter(setting => {
     return setting.entity.title.toLowerCase().indexOf(lowerCased) > -1;
    });
  }
}
